import Reveal from '../../common/Reveal';
import fallbackBackground from '../../../assets/images/achievement.jpg';

function AchievementSection({ banner, stats = [], statsLoading = false }) {
  const hasStats = !statsLoading && stats?.length > 0;
  if (!banner && !hasStats) return null;

  return (
    <section className="overflow-hidden">
      {banner ? (
        <div
          className="relative min-h-[280px] overflow-hidden bg-cover bg-no-repeat px-4 py-16 sm:px-6 sm:py-20 lg:min-h-[320px] lg:px-8 lg:py-24 xl:h-[394px] xl:pt-[114px] xl:pb-[114px] grayscale"
          style={{
            backgroundImage: `url("${banner.imageUrl || fallbackBackground}")`,
          }}
        >
          <div className="absolute inset-0 bg-black/60 z-0"></div>
          <div className="relative z-10 mx-auto max-w-4xl text-center">
            {banner.title ? (
              <Reveal variant="up">
                <h2 className="text-4xl font-bold text-[#EBE7E7] sm:text-5xl lg:text-6xl xl:text-[64px]">
                  {banner.title}
                </h2>
              </Reveal>
            ) : null}

            {banner.subtitle ? (
              <Reveal variant="up" delay={90}>
                <p className="mx-auto mt-4 max-w-2xl text-base font-semibold text-[#D9D9D9] sm:text-lg lg:text-[20px]">
                  {banner.subtitle}
                </p>
              </Reveal>
            ) : null}
          </div>
        </div>
      ) : null}

      {hasStats ? (
        <div className="bg-[#CCCCCC] px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
          <ul className="mx-auto grid max-w-6xl grid-cols-2 gap-10 sm:grid-cols-4 sm:gap-12">
            {stats.map((stat, index) => (
              <li key={stat.id} className="text-center">
                <Reveal variant="zoom" delay={index * 90}>
                  <p className="text-3xl font-bold text-[#1B1B1B] lg:text-[36px] xl:text-[40px]">{stat.value}</p>
                  <p className="mt-2 text-base font-medium text-[#1B1B1B] lg:text-lg xl:text-[20px]">{stat.label}</p>
                </Reveal>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </section>
  );
}

export default AchievementSection;
